import React from 'react'
import userIcon from "../../assets/img/icons/user.png"


const User = () => {
    let u = JSON.parse(localStorage.getItem('user'));

    return (
        <div className='user-head'>
            <div className='user-head-parent'>
                <div className='user-head-icon'>
                    <img src={userIcon} alt='user' />
                </div>
                <span>Welcome {u.full_name}</span>
            </div>
        </div>
    )
}
export default User
